import ActionTypes from "../actions/actionTypes";
import { isRecurringSubscription, isSubscriptionActive } from "../../utils/subscriptionUtils";
import logger from "../../utils/logger";


const initialState = {
  subscriptions: [],
  recurringSubscriptions: [],
  addOnSubscriptions: [],
  activeAddOnSubscriptions: [],
  activeSubscription: null,
  loading: false,
  error: null,
  subscriptionWallChecked: false,
  featureFlags: {
    BOOKING_BY_CUSTOMER: false,
    CUSTOMER_MANAGEMENT: false,
    CALENDAR_VIEW_OF_BOOKINGS: false,
    TEAM_MESSAGING: false,
    CUSTOMER_MESSAGING: false,
    BOOKING_FOR_CUSTOMER: false,
    MULTI_LOCATION: false,
    WHITE_LABELING: false,
  },
  featureFlagsLoading: false,
  featureFlagsError: null,
  // Applicable package state
  applicablePackage: null,
  applicablePackageLoading: false,
  applicablePackageError: null,
};

const subscriptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_SUBSCRIPTIONS: {
      const recurringSubscriptions = action.payload.filter(sub => isRecurringSubscription(sub));
      const addOnSubscriptions = action.payload.filter(sub => !isRecurringSubscription(sub));
      const activeAddOnSubscriptions = addOnSubscriptions.filter(sub => isSubscriptionActive(sub));

      return {
        ...state,
        subscriptions: action.payload,
        recurringSubscriptions,
        addOnSubscriptions,
        activeAddOnSubscriptions,
        error: null,
      };
    }

    case ActionTypes.SET_SUBSCRIPTIONS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case ActionTypes.SET_SUBSCRIPTIONS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case ActionTypes.CLEAR_SUBSCRIPTIONS:
      logger.log("JGNGNNFM: CLEAR_SUBSCRIPTIONS reducer executed");
      return {
        ...state,
        subscriptions: [],
        recurringSubscriptions: [],
        addOnSubscriptions: [],
        activeAddOnSubscriptions: [],
        activeSubscription: null,
        error: null,
        loading: false,
      };

    case ActionTypes.SET_ACTIVE_SUBSCRIPTION:
      return {
        ...state,
        activeSubscription: action.payload,
      };

    case ActionTypes.SET_SUBSCRIPTION_WALL_CHECKED:
      return {
        ...state,
        subscriptionWallChecked: action.payload,
      };

    case ActionTypes.SET_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: action.payload,
        featureFlagsError: null,
      };

    case ActionTypes.SET_FEATURE_FLAGS_LOADING:
      return {
        ...state,
        featureFlagsLoading: action.payload,
      };

    case ActionTypes.SET_FEATURE_FLAGS_ERROR:
      return {
        ...state,
        featureFlagsError: action.payload,
        featureFlagsLoading: false,
      };

    case ActionTypes.CLEAR_FEATURE_FLAGS:
      return {
        ...state,
        featureFlags: {
          BOOKING_BY_CUSTOMER: false,
          CUSTOMER_MANAGEMENT: false,
          CALENDAR_VIEW_OF_BOOKINGS: false,
          TEAM_MESSAGING: false,
          CUSTOMER_MESSAGING: false,
          BOOKING_FOR_CUSTOMER: false,
          MULTI_LOCATION: false,
          WHITE_LABELING: false,
        },
        featureFlagsError: null,
        featureFlagsLoading: false,
      };

    case ActionTypes.SET_APPLICABLE_PACKAGE:
      return {
        ...state,
        applicablePackage: action.payload,
        applicablePackageError: null,
      };

    case ActionTypes.SET_APPLICABLE_PACKAGE_LOADING:
      return {
        ...state,
        applicablePackageLoading: action.payload,
      };

    case ActionTypes.SET_APPLICABLE_PACKAGE_ERROR:
      return {
        ...state,
        applicablePackageError: action.payload,
        applicablePackageLoading: false,
      };

    case ActionTypes.CLEAR_APPLICABLE_PACKAGE:
      return {
        ...state,
        applicablePackage: null,
        applicablePackageError: null,
        applicablePackageLoading: false,
      };

    case ActionTypes.LOGOUT_USER:
      // Reset subscription state on logout
      return initialState;

    default:
      return state;
  }
};

export default subscriptionReducer;
